var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.25C9.932 6.25 8.25 7.932 8.25 10C8.25 12.068 9.932 13.75 12 13.75C14.068 13.75 15.75 12.068 15.75 10C15.75 7.932 14.068 6.25 12 6.25ZM12 12.25C10.759 12.25 9.75 11.241 9.75 10C9.75 8.759 10.759 7.75 12 7.75C13.241 7.75 14.25 8.759 14.25 10C14.25 11.241 13.241 12.25 12 12.25ZM11.996 2.25C7.58 2.25 4.25 5.582 4.25 10C4.25 16.208 8.986 20.076 11.021 21.45C11.317 21.65 11.656 21.75 11.996 21.75C12.334 21.75 12.673 21.65 12.969 21.451C15.008 20.074 19.75 16.201 19.75 9.99902C19.75 5.58102 16.417 2.25 11.996 2.25ZM12.13 20.208C12.047 20.264 11.944 20.264 11.861 20.208C10.427 19.24 5.75 15.643 5.75 10C5.75 6.437 8.435 3.75 11.996 3.75C15.561 3.75 18.25 6.437 18.25 10C18.25 15.483 13.97 18.966 12.13 20.208Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.f497ef2e.svg";
export { ForwardRef as ReactComponent };